/* eslint-disable react/prop-types */
import React from "react";
import { Box } from "@mui/material";
import LoaderIcon from "../../../assets/svg/LoaderIcon";
import styles from "./Loader.styles";

function Loader({ size }) {
  return (
    <Box style={styles.loader}>
      <LoaderIcon size={size} style={styles.icon} />
    </Box>
  );
}

export default Loader;
